// .spine-rail already stops the strip's fill at the footer in pure CSS, so the
// band can never flash parchment on a fast scroll. The spine's *contents* are
// fixed to the viewport though, and its bottom control would end up sitting on
// the footer — publish how far the footer reaches into the viewport so
// _spine.scss can trim the contents box to match.

const ROOT = document.documentElement;
const PROP = '--spine-footer-inset';

export function initSpineFooterInset(): void {
  const footerEl = document.querySelector<HTMLElement>('.site-footer');
  if (!footerEl || !document.querySelector('.js-spine')) return;

  const footer = footerEl;
  let frame = 0;
  let last = -1;

  function update(): void {
    frame = 0;
    // Clamped to the viewport: a footer taller than the screen shouldn't drive
    // the contents box's height negative.
    const intrusion = Math.min(
      window.innerHeight,
      Math.max(0, window.innerHeight - footer.getBoundingClientRect().top)
    );
    const inset = Math.round(intrusion);
    if (inset === last) return;
    last = inset;
    ROOT.style.setProperty(PROP, `${inset}px`);
  }

  function schedule(): void {
    if (frame) return; // coalesces scroll/resize bursts into one rAF
    frame = requestAnimationFrame(update);
  }

  update();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
}
